

/// <reference path="DBMappingEntity.ts" />

// Generated class DBMappingEntityLocationCategory_ManagedObject

class DBMappingEntityLocationCategory_ManagedObject extends DBMappingEntity
{
}
